// icon:flower | Material Design Icons https://materialdesignicons.com/ | Austin Andrews
import * as React from "react";

export default function IconPhone(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14 14"
      fill="currentColor"
      height="1em"
      width="1em"
      {...props}
    >
        <path
              d="m13.483069 9.60581477-2.9638171-1.2714964c-.3498419-.14918486-.7561505-.05011235-.99805635.24336168L8.31532477 10.0515221c-1.89671208-.93286254-3.43124123-2.46739169-4.36410378-4.36410377l1.47384206-1.20587078c.2934287-.24181518.39250392-.64802357.24336168-.99778288L4.39692833.51693973C4.23286405.13730228 3.82100626-.0709275 3.41801282.02201317L.66173674.65912857c-.3881164.08778314-.66319843.43334073-.6617309.83125787C.00000584 8.41635039 5.61373671 14 12.5096223 14c.3992171.0007458.7456791-.2751973.8342657-.6644624l.6341075-2.7535417c.0928666-.402273-.1155451-.81333917-.4949265-.97618113Zm-.9898531 3.51917393C6.08131926 13.1167855.88322321 7.92142384.87775441 1.50952725l2.72346327-.6289122 1.25782439 2.93647309-1.99064383 1.62696851c1.32345002 2.8219017 2.85744891 4.36136939 5.69028821 5.69028825L10.185655 9.14370103l2.9364731 1.25782437-.6289122 2.7234633Z"/>
    </svg>
  );
}
